export enum Role {
  CSS = 'CSS',
  CSSPlus = 'CSS Plus',
  Technician = 'Technician',
  Management = 'Management',
  SuperManagement = 'Super Management',
  TeamLeaders = 'Team Leaders',
  SuperManagementDEV = 'Super Management DEV',
  AdministrationAssistant = 'Administration Assistant',
  HRManagement = 'HR Management',
  Administration = 'Administration',
  AdministrationAssistantCopy = 'Administration Assistant Copy',
  ServiceCentre = 'Service Centre',
  ServiceCentreTechnician = 'Service Centre - Technician',
}

type SkillResponse = {
  name: string;
  icon: string;
  class: string;
  intraining: 0 | 1;
};

export type UserResponse = {
  name: string;
  ID: number;
  role: Role | '';
  switchvox_extension: string;
  skillsets: SkillResponse[];
};

type Skill = {
  [k in keyof SkillResponse as Exclude<k, 'class' | 'intraining'>]: SkillResponse[k];
} & {
  type: string;
  inTraining: boolean;
};

export type User = {
  [k in keyof UserResponse as Exclude<k, 'skillsets'>]: UserResponse[k];
} & {
  skillsets: Skill[];
};

export type SystemUser = {
  ID: number;
  email: string;
  name: string;
  username: string;
};
